<template>
  <div>
    <v-container>
      <h1>{{title}}</h1>
      <v-row>
        <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
          <v-text-field :value="model.header.fullName" label="Employee" :class="classPadding"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <v-text-field :value="model.header.desDesc" label="Designation" :class="classPadding"></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <v-text-field :value="model.header.depDesc" label="Department" :class="classPadding"></v-text-field>
        </v-col>

        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <v-text-field :value="model.header.secDesc" label="Section" :class="classPadding"></v-text-field>
        </v-col>

        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <v-text-field :value="model.header.movementTypeDesc" label="Movement Type" :class="classPadding"></v-text-field>
        </v-col>
      </v-row>

      <v-data-table :items="items" :headers="headers">
        <template v-slot:item.actions="{ item }">
          <!-- <v-btn
            @click.stop="edit(item)"
            text
            icon
            >
            <v-icon color="primary">mdi-pencil</v-icon>
          </v-btn> -->
        </template>
        <template v-slot:item.inCharge="{ item }">
          <v-btn
            @click.stop="viewInCharge(item)"
            text
            outlined
            >
            View
          </v-btn>
        </template>
        <template v-slot:item.stepSequence="{ item }">
          <span v-if="!(item.subStepSequence > 0)">{{item.stepSequence}}</span>
        </template>

        <template v-slot:item.targetDate="{ item }">
          <span>{{item.targetDate | dateFormat}}</span>
        </template>
      </v-data-table>

      <v-row>
        <v-col>
          <v-btn color="success" @click.stop="approve" :loading="loading">Approve</v-btn>&nbsp;
          <v-btn @click.stop="decline" :loading="loading">Decline</v-btn>
        </v-col>
      </v-row>
    </v-container>
     <v-dialog v-model="viewDialog" width="600" persistent>
      <v-card>
        <v-card-title>
          <span>In Charge</span>
        </v-card-title>
        <v-card-text>
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    Employee Code
                  </th>
                  <th class="text-left">
                    Name
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in inCharge"
                  :key="item.empCode"
                >
                  <td>{{ item.empCode }}</td>
                  <td>{{ item.fullName }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click.stop="viewDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { headers } from "../plan/variables.js"
export default {
  data: () => ({
    classPadding: "my-0 py-0",
    title: "Onboarding Schedule Approval Incharge",
    model: {},
    items: [],
    headers,
    loading: false,
    viewDialog: false,
    selectedIndex: -1,
    inCharge: []
  }),
  methods: {
    getDetails(transNo) {
      this.$axios.get(`/api/onboardingSched/${transNo}`)
        .then(({ data }) => {
          this.model = data;
          this.items = data.details
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message)
        })
    },
    approve() {
     this.$confirm('Do you want to approve this transaction?').then(res => {
        if(res) {
          this.submitApproval("APPROVED")
        }
      })
    },
    decline() {
      this.$confirm('Do you want to decline this transaction?').then(res => {
        if(res) {
          this.submitApproval("DECLINED")
        }
      })
    },
    submitApproval(status) {
      var param = {
        status,
        transNo: this.$route.params.transNo
      }
      this.loading = true
      this.$axios.post(`/api/onboardingSched/approval`, param)
        .then(({ data }) => {
          this.$toast.success(data.message)
          this.$router.push('/onboarding-sched-approval')
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.loading = false;
        })
    },
    viewInCharge(item) {
      this.selectedIndex = this.items.indexOf(item);
      this.inCharge = item.inChargeList;
      this.viewDialog = true;
    },
  },
  created() {
    this.getDetails(this.$route.params.transNo)
  }
}
</script>